import { getLanguageResources } from "@/helpers/i18n/i18n.helpers";

import i18n from "i18next";
import BrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const browserLanguageDetector = new BrowserLanguageDetector();

i18n
  .use(browserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources: getLanguageResources(),
    keySeparator: ".",
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        reseller: "Aircall",
      },
    },
  });

export default i18n;
